/*
* Lomtec jQuery functions / extensions scripts
*
* Copyright (c) 2012 Lomtec.com
* http://www.lomtec.com
*
* Author : Imrich Szolik
* Released: February 2012
*/
(function ($) {

    /* jQuery function extension */

    $.fn.extend({
        //
        switchClass: function (on, off, val) {
            var element = $(this);

            if (val === undefined) {
                if (element.hasClass(on)) {
                    element.removeClass(on);
                    element.addClass(off);
                    return false;
                }
                else {
                    element.removeClass(off);
                    element.addClass(on);
                    return true;
                }
            }
            else {
                if (val) {
                    element.removeClass(off);
                    element.addClass(on);
                    return true;
                }
                else {
                    element.removeClass(on);
                    element.addClass(off);
                    return false;
                }
            }
        },
        //
        switchToElement: function (el) {
            $(this).hide();
            el.show();
        },
        //
        animateSwitchClass: function (class1, class2, val) {
            var elem = $(this);

            elem.animate({
                opacity: 0.25
            }, 200, function () {
                elem.switchClass(class1, class2, val);
                elem.animate({ opacity: 1 }, 400, function () {
                    elem.removeClass(class1);
                });
            });
        },
        //
        setClass: function (val, cls) {
            if (val === undefined) val = true;
            if (cls === undefined) cls = 'active';
            var element = $(this);

            if (val === true) {
                element.addClass(cls);
            }
            else {
                element.removeClass(cls);
            }
        },
        //
        loadingClass: function (val) {
            var element = $(this);
            element.setClass(val, 'loading');
        },
        //
        activeClass: function (val) {
            var element = $(this);
            element.setClass(val, 'active');
        },
        //
        hiddenClass: function (val) {
            var element = $(this);
            if (val === undefined) {
                element.toggleClass('hidden');
            }
            else {
                if (val === true) element.addClass("hidden");
                else element.removeClass('hidden');
            }
        },
        //
        validateWithoutClientCode: function () {
            var element = $(this);
            element.valid();
            $('span[data-valmsg-for=ClientCode]', element).removeClass('field-validation-error');
        }
    });

    /* jQuery extension */

    $.extend({
        //
        urlGenerator: function (url, action, id, parameter) {
            var url = url;
            if (action !== undefined && action !== null && action !== '') url = url + '/' + action;
            if (url.length > 0 && url[url.length - 1] != '/') url = url + '/';
            if (id !== undefined && id != null && id !== '') { url = url + ($.isArray(id) == true ? id.join('/') : id.toString()); }
            if (parameter !== undefined && parameter != null && parameter !== '') { url = url + '?' + ($.isArray(parameter) == true ? parameter.join('&') : parameter.toString()); }
            return url;
        },
        //
        updateAction: function (options) {
            if (options === undefined) return false;
            if (options.url === undefined) return false;

            var url = $.urlGenerator(options.url, options.action, options.id, options.parameter);
            var request = options.request || "GET";
            var cache = options.cache || false;

            $.ajax(url, { type: request, cache: cache }).then(
                    function (response) {

                        try { if ($.isFunction(options.success)) options.success(true, response); }
                        catch (e) { }
                    },
                    function () {

                        try { if ($.isFunction(options.error)) options.error(); }
                        catch (e) { }
                    }
                );
            return true;
        },
        //
        updateJsonAction: function (options) {
            if (options === undefined) return false;
            if (options.url === undefined) return false;

            var url = $.urlGenerator(options.url, options.action, options.id, options.parameter);
            var request = options.request || "POST";
            var cache = options.cache || false;

            $.ajax(url, { type: request, cache: cache }).then(
                    function (response) {
                        try {
                            if ($.isPlainObject(response)) {
                                if (response.status === true) {

                                    try { if ($.isFunction(options.success)) options.success(true, response); }
                                    catch (e) { }

                                }
                                else {

                                    try { if ($.isFunction(options.success)) options.success(false, response); }
                                    catch (e) { }

                                }
                            }
                        }
                        catch (e) {
                            try { if ($.isFunction(options.success)) options.success(false, response); }
                            catch (e) { }
                        }
                    },
                    function () {
                        try { if ($.isFunction(options.error)) options.error(); }
                        catch (e) { }
                    }

                );
            return false;
        },
        //
        updateContent: function (options) {
            if (options === undefined) return false;
            if (options.content === undefined || options.url === undefined) return false;

            var update = $('#' + options.content);
            var load = options.loading === false ? false : true;
            if (load) update.loadingClass();

            var url = $.urlGenerator(options.url, options.action, options.id, options.parameter);
            var request = options.request || "GET";
            var cache = options.cache !== true ? false : true;

            $.ajax(url, { type: request, cache: cache }).then(
                    function (response) {
                        try {
                            update.replaceWith(response);

                            try { if ($.isFunction(options.success)) options.success(true, response); }
                            catch (e) { }
                        }
                        catch (e) {
                            if (load) update.loadingClass(false);

                            try { if ($.isFunction(options.success)) options.success(false, response); }
                            catch (e) { }
                        }
                    },
                    function () {
                        if (load) update.loadingClass(false);

                        try { if ($.isFunction(options.error)) options.error(); }
                        catch (e) { }
                    }
                );
            return true;
        },
        //
        updateJsonContent: function (options) {
            function loading(content, set) {
                if (content === false) return;

                if ($.isArray(content) === true) {
                    $.each(content, function (i, c) {
                        try {
                            if (set === false) $('#' + c.id).loadingClass(false);
                            else $('#' + c.id).loadingClass();
                        }
                        catch (e) { }
                    });
                }
                else {
                    try {
                        if (set === false) $('#' + content).loadingClass(false);
                        else $('#' + content).loadingClass();
                    }
                    catch (e) { }
                }
            }

            function update(content, data) {
                if (data === undefined || data == null) return;

                if (content === false) {
                    if ($.isArray(data) === true) {
                        $.each(data, function (i, d) {
                            if ($.isPlainObject(d) === true) {
                                try { $('#' + d.id).replaceWith(d.content); }
                                catch (e) { }
                            }
                        });
                    }
                    else {
                        if ($.isPlainObject(data) === true) {
                            try { $('#' + data.id).replaceWith(data.content); }
                            catch (e) { }
                        }
                    }
                }
                else {
                    if ($.isArray(content) === true) {
                        $.each(content, function (i, c) {
                            try {
                                var out = data[c.name];
                                if (out !== undefined) $('#' + c.id).replaceWith(out);
                            }
                            catch (e) { }
                        });
                    }
                    else {
                        $('#' + content).replaceWith(data);
                    }
                }
            }
            //
            //-------------------------------------------------------------
            //
            if (options === undefined) return false;
            if (options.dynamic === true) options.content = false;
            if (options.content === undefined || options.url === undefined) return false;

            var load = options.loading === false ? false : true;
            if (load) loading(options.content);

            var url = $.urlGenerator(options.url, options.action, options.id, options.parameter);
            var request = options.request || "POST";
            var cache = options.cache || false;

            $.ajax(url, { type: request, cache: cache }).then(
                    function (response) {
                        try {
                            if ($.isPlainObject(response) === true && response.status === true) {
                                update(options.content, response.html);

                                try {
                                    if ($.isFunction(options.success)) options.success(true, response);
                                }
                                catch (e) {
                                }
                                return;
                            }
                        }
                        catch (e) { }

                        if (load) loading(options.content, false);

                        try { if ($.isFunction(options.success)) options.success(false, response); }
                        catch (e) { }

                    },
                    function () {
                        if (load) loading(options.content, false);

                        try { if ($.isFunction(options.error)) options.error(); }
                        catch (e) { }
                    }
                );
            return false;
        }
    });
})(jQuery);
//
//----------------- Global functions ------------------
//
function openDialog(url, name) {
    var newwindow = window.open(url, name | '', 'height=800,width=1024');
    if (window.focus) { newwindow.focus(); }
    return false;
};